import styled from "styled-components";
import { Colors } from "utils/colors";

export const GrayCard = styled.div`
  border-radius: 0.8rem;
  background: ${Colors.grey700};
  padding: 2.4rem;
  margin-bottom: 2.4rem;
  margin-left: auto;
  margin-right: auto;
  width: 55%;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;

export const GrayHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1.6rem;
  border-bottom: 0.5px solid ${Colors.grey600};
`;

export const GrayBody = styled.div`
  padding-top: 2.4rem;
`;

export const TableContainer = styled.div`
  border-radius: 0.6rem;
  border: 0.5px solid ${Colors.grey600};
  border-top: none;
  :first-child {
    border-radius: 0.6rem 0.6rem 0 0;
  }
`;

export const TableItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2.2rem 1.6rem;
  border-top: 0.5px solid ${Colors.grey600};
`;

export const HeaderButton = styled.div`
  display: block;
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;
export const MobileButton = styled.div`
  margin-top: 2.4rem;
  width: 100%;
  display: none;
  @media only screen and (max-width: 769px) {
    display: block;
  }
`;
